module.exports = __webpack_public_path__ + "static/media/menu.4ea01b16.svg";